import React from "react";
import PropTypes from "prop-types";
import { Type } from "discover.medical.react-component-library";
import { ErrorTitle, ErrorWrapper } from "./index.styled";

const SpecialtiesError = ({ name, message }) => {
  return (
    <ErrorWrapper>
      <ErrorTitle>
        <p dangerouslySetInnerHTML={{ __html: name }} />
      </ErrorTitle>

      <Type element="p">{message}</Type>
    </ErrorWrapper>
  );
};

SpecialtiesError.defaultProps = {
  name: "We're Sorry! This page is temporarily unavailable.",
  message: "We are working on resolving the problem. Please try again shortly.",
};

SpecialtiesError.propTypes = {
  name: PropTypes.string,
  message: PropTypes.string,
};

SpecialtiesError.displayName = "SpecialtiesError";
export default SpecialtiesError;
